import { z } from 'zod';

export const DatabaseAnalysisStatus = z.enum([
  'NotStarted',
  'Processing',
  'Failed',
  'Complete',
]);

export type DatabaseAnalysisStatus = z.infer<typeof DatabaseAnalysisStatus>;
